import React from 'react';
import Hero from './HeroArea';
import About from './AboutArea';
import Service from './ServiceArea';
import Appointment from './AppointmentArea';
import Newsletter from '../../components/Newsletter';
import Team from './TeamArea';
import Testimonial from './TestimonialArea';
import Price from './PriceArea';
import Blog from './BlogArea';

const HomeTwoMain = () => {
  return (
    <main>
      <Hero />
      <About />
      <Service />
      <Appointment />
      <Newsletter />
      <Team />
      <Testimonial />
      <Price />
      <Blog />
    </main>
  );
};

export default HomeTwoMain;
